<script setup>
import { computed } from 'vue';

const props = defineProps({
  type: {
    type: String,
    required: true,
    validator: value => ['danger', 'warning', 'success'].includes(value),
  },
  text: {
    type: String,
    required: true,
  },
});

const badgeClasses = computed(() => {
  switch (props.type) {
    case 'danger':
      return 'bg-red-100 text-red-800';
    case 'warning':
      return 'bg-yellow-100 text-yellow-800';
    case 'success':
      return 'bg-green-100 text-green-800';
    default:
      return 'bg-slate-100 text-slate-800';
  }
});
</script>

<template>
  <span
    class="inline-flex items-center px-2.5 py-1 rounded-lg text-sm font-medium"
    :class="badgeClasses"
  >
    {{ text }}
  </span>
</template>
